import { Buffer } from 'buffer'
export const convertToBase64 = (value: string) => {
  console.log('convertToBase64-value', value)
  return Buffer.from(value).toString('base64')
}
export const convertBas64ToString = (value: string) => {
  return Buffer.from(value, 'base64').toString('ascii')
}
